import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography, Divider } from '@mui/material';
import 'dayjs/locale/ko';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

export const SearchBox = ({ formik, handleDownExcel }) => {
    const [searchStrtDt, setSearchStrtDt] = useState(null);
    const [searchEndDt, setSearchEndDt] = useState(null);

    useEffect(() => {
        if (formik.values.searchStrtDt) {
            setSearchStrtDt(dayjs(formik.values.searchStrtDt));
        }
        if (formik.values.searchEndDt) {
            setSearchEndDt(dayjs(formik.values.searchEndDt));
        }
    }, [formik.values.searchStrtDt, formik.values.searchEndDt]);

    const onChangeDate = (newValue, name) => {
        formik.setFieldValue(name, newValue);
    };

    return (
        <Box
            component="form"
            noValidate
            autoComplete="off"
            sx={{
                mx: 1
            }}
            onSubmit={formik.handleSubmit}
        >
            {/* 휴대폰 폭: 날짜 두 칸을 한 줄(반반)에, 버튼은 다음 줄로. 날짜가 "2026-01-0"처럼 잘리고
                "엑셀 다운로드"가 4줄로 꺾였다(2026-10-08 모바일 점검). */}
            <Box sx={{
                display: 'flex', justifyContent: 'flex-end', alignItems: 'center',
                flexWrap: { xs: 'wrap', sm: 'nowrap' }, rowGap: 1,
                '& > :nth-of-type(-n+2)': { flex: { xs: '1 1 40%', sm: 'initial' }, minWidth: { xs: 0, sm: 'auto' } },
                '& .MuiButton-root': { whiteSpace: 'nowrap' },
            }}>
                <Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                        <DatePicker
                            label="매출 시작일"
                            format="YYYY-MM-DD"
                            mask={'____-__-__'}
                            id="searchStrtDt"
                            name="searchStrtDt"
                            value={dayjs(searchStrtDt)}
                            onChange={(newValue) => {
                                setSearchStrtDt(dayjs(newValue));
                                onChangeDate(dayjs(newValue), 'searchStrtDt');
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="standard"
                                    fullWidth
                                    error={
                                        formik.touched.searchStrtDt &&
                                        Boolean(formik.errors.searchStrtDt)
                                    }
                                    helperText={
                                        formik.touched.searchStrtDt && formik.errors.searchStrtDt
                                    }
                                />
                            )}
                        />
                    </LocalizationProvider>
                </Box>
                <Box sx={{ mx: 1 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                        <DatePicker
                            label="매출 종료일"
                            format="YYYY-MM-DD"
                            mask={'____-__-__'}
                            id="searchEndDt"
                            name="searchEndDt"
                            value={dayjs(searchEndDt)}
                            onChange={(newValue) => {
                                setSearchEndDt(dayjs(newValue));
                                onChangeDate(dayjs(newValue), 'searchEndDt');
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="standard"
                                    fullWidth
                                    error={
                                        formik.touched.searchEndDt &&
                                        Boolean(formik.errors.searchEndDt)
                                    }
                                    helperText={
                                        formik.touched.searchEndDt && formik.errors.searchEndDt
                                    }
                                />
                            )}
                        />
                    </LocalizationProvider>
                </Box>
                <Box sx={{ ml: 2 }}>
                    <Button
                        type="submit"
                        color="info"
                        variant="contained"
                        disabled={formik.isSubmitting}
                    >
                        검색
                    </Button>
                </Box>
                <Box sx={{ mx: 1 }}>
                    <Button
                        type="button"
                        color="success"
                        variant="contained"
                        onClick={handleDownExcel}
                    >
                        엑셀 다운로드
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};
